import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Row } from 'antd';
import {
	BlacklistModalContent,
	BlacklistModalTitle,
	BlacklistModalDescription,
	BlacklistReasonLabel,
	BlacklistReasonInput,
	ModalCancelButton,
	ModalConfirmButton,
} from './clientFormStyles';

export default function ClientBlacklistModal({ open, onCancel, onConfirm, loading = false }) {
	const [blacklistReason, setBlacklistReason] = useState('');

	// Clear reason when modal closes
	useEffect(() => {
		if (!open) {
			setBlacklistReason('');
		}
	}, [open]);

	const handleCancel = () => {
		if (loading) return; // Prevent cancel during loading
		setBlacklistReason('');
		onCancel();
	};

	const handleConfirm = async () => {
		if (loading) {
			return; // Prevent multiple submissions
		}
		try {
			await onConfirm(blacklistReason);
		} catch (error) {
			// Error is handled by parent component
		}
		// Don't clear reason here - let parent handle it after success
	};

	return (
		<Modal
			title={null}
			open={open}
			onCancel={handleCancel}
			footer={null}
			closable={false}
			width={480}
			centered
		>
			<BlacklistModalContent>
				<BlacklistModalTitle>Are you sure?</BlacklistModalTitle>
				<BlacklistModalDescription>
					Blacklisting this client will block all future transactions and access. Please
					confirm to proceed.
				</BlacklistModalDescription>

				<BlacklistReasonLabel>Reason for Blacklisting</BlacklistReasonLabel>
				<BlacklistReasonInput
					value={blacklistReason}
					onChange={(e) => setBlacklistReason(e.target.value)}
					placeholder="Add your reasons"
					rows={3}
				/>

				<Row justify="start" style={{ marginTop: 24, gap: 16 }}>
					<ModalCancelButton type="button" onClick={handleCancel} disabled={loading}>
						Cancel
					</ModalCancelButton>
					<ModalConfirmButton type="button" onClick={handleConfirm} disabled={loading}>
						{loading ? 'Blacklisting...' : 'Confirm'}
					</ModalConfirmButton>
				</Row>
			</BlacklistModalContent>
		</Modal>
	);
}

ClientBlacklistModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	loading: PropTypes.bool,
};
